import { SortDirection } from "@redotech/redo-model/tables/table";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const customerPersonaGroupSchema = z.object({
  name: z.string(),
  emoji: z.string(),
});

export const customerProfileSchema = z.object({
  _id: zExt.objectId(),
  name: z.string(),
  email: z.string().optional(),
  currentLocation: z.string().optional(),
  personaGroups: z.array(customerPersonaGroupSchema),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type CustomerProfileSchema = z.infer<typeof customerProfileSchema>;

export const paginateCustomersWithPersonas = {
  name: "paginateCustomersWithPersonas" as const,
  input: z.object({
    searchText: z.string().optional(),
    sort: z
      .object({ key: z.string(), direction: createEnum(SortDirection) })
      .optional(),
    page: z.number().positive().default(1),
    pageSize: z.number().positive().default(20),
  }),
  output: z.object({
    data: z.array(customerProfileSchema),
    totalCount: z.number(),
  }),
};
